import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", data.token);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-glow grain flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="glass rounded-3xl p-8 sm:p-10 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex items-center gap-2.5 mb-8">
          <img src="/logo.png" alt="Logo Iris Photo" className="h-9 w-9 rounded-xl object-cover" />
          <span className="text-lg font-semibold tracking-tight text-white">Panel de administración</span>
        </div>

        <div className="flex flex-col gap-2 mb-5">
          <Label htmlFor="email" className="text-white/80">Email</Label>
          <div className="relative">
            <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-white/40" />
            <Input
              data-testid="admin-email-input"
              id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="tucorreo@dominio.com"
              className="pl-10 h-11 bg-white/5 border-white/15 text-white placeholder:text-white/35 rounded-xl"
            />
          </div>
        </div>

        <div className="flex flex-col gap-2 mb-7">
          <Label htmlFor="password" className="text-white/80">Contraseña</Label>
          <div className="relative">
            <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-white/40" />
            <Input
              data-testid="admin-password-input"
              id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="pl-10 h-11 bg-white/5 border-white/15 text-white placeholder:text-white/35 rounded-xl"
            />
          </div>
        </div>

        <Button
          data-testid="admin-login-button"
          type="submit" disabled={loading}
          className="w-full h-12 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500 hover:from-indigo-400 hover:to-violet-400 text-white border-0 text-base"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entrar"}
        </Button>
      </form>
    </div>
  );
}
